module.exports = "https://cdn.realtymogul.com/static/media/retire_distinct_strategies.f105572f.jpg";